import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationRawOutputsIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M136 136V888H888V136H136ZM96 64C78.3269 64 64 78.3269 64 96V928C64 945.673 78.3269 960 96 960H928C945.673 960 960 945.673 960 928V96C960 78.3269 945.673 64 928 64H96Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M255.088 710.869V653.119H287.422C307.273 653.119 319.154 663.496 319.154 681.844C319.154 700.492 307.123 710.869 287.422 710.869H255.088ZM255.088 793.734V746.061H284.564L311.635 798.848C319.756 814.789 326.674 820.203 339.758 820.203C354.195 820.203 364.422 810.578 364.422 796.893C364.422 791.629 363.068 785.914 360.361 781.252L333.592 733.879C355.85 723.502 368.482 703.199 368.482 677.332C368.482 637.93 340.209 613.717 294.189 613.717H239.898C216.287 613.717 205.309 625.297 205.309 649.66V793.734C205.309 810.729 214.482 820.504 230.574 820.504C246.365 820.504 255.088 810.879 255.088 793.734Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M409.238 820.654C422.473 820.654 429.541 813.887 434.504 796.441L442.475 771.928H511.504L519.324 796.441C524.287 813.436 531.957 820.654 545.191 820.654C559.479 820.654 568.803 812.232 568.803 799.148C568.803 793.885 567.449 787.869 564.742 779.447L519.475 646.352C511.203 621.838 499.773 612.213 478.117 612.213C456.461 612.213 444.73 621.988 436.609 646.352L391.191 779.447C387.732 789.523 386.379 795.238 386.379 800.201C386.379 812.232 395.703 820.654 409.238 820.654ZM452.701 735.984L476.012 658.232H478.418L501.428 735.984H452.701Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M610.762 795.088C616.176 814.037 625.951 820.203 640.84 820.203C655.578 820.203 665.805 811.48 670.166 795.088L698.439 687.859H700.395L728.367 793.734C733.18 812.383 743.256 820.203 759.047 820.203C774.086 820.203 783.109 812.383 787.922 795.088L828.076 649.359C829.129 645.75 829.881 639.283 829.881 635.072C829.881 621.537 819.955 611.912 805.818 611.912C792.434 611.912 784.012 620.785 780.252 639.133L755.738 752.828H753.182L725.66 638.381C721.148 620.033 713.328 611.912 699.342 611.912C685.355 611.912 677.836 619.732 673.324 638.381L645.652 752.828H643.246L617.68 639.133C613.469 620.484 605.648 611.912 592.414 611.912C577.977 611.912 568.051 621.537 568.051 635.523C568.051 639.584 568.953 646.201 570.607 652.367L610.762 795.088Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 236C200 218.327 214.327 204 232 204H333C350.673 204 365 218.327 365 236V244C365 261.673 350.673 276 333 276H232C214.327 276 200 261.673 200 244V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 236C429 218.327 443.327 204 461 204H563C580.673 204 595 218.327 595 236V244C595 261.673 580.673 276 563 276H461C443.327 276 429 261.673 429 244V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 236C659 218.327 673.327 204 691 204H792C809.673 204 824 218.327 824 236V244C824 261.673 809.673 276 792 276H691C673.327 276 659 261.673 659 244V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 372C200 354.327 214.327 340 232 340H333C350.673 340 365 354.327 365 372V380C365 397.673 350.673 412 333 412H232C214.327 412 200 397.673 200 380V372Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 372C429 354.327 443.327 340 461 340H563C580.673 340 595 354.327 595 372V380C595 397.673 580.673 412 563 412H461C443.327 412 429 397.673 429 380V372Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 508C200 490.327 214.327 476 232 476H333C350.673 476 365 490.327 365 508V516C365 533.673 350.673 548 333 548H232C214.327 548 200 533.673 200 516V508Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 508C429 490.327 443.327 476 461 476H563C580.673 476 595 490.327 595 508V516C595 533.673 580.673 548 563 548H461C443.327 548 429 533.673 429 516V508Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 372C659 354.327 673.327 340 691 340H792C809.673 340 824 354.327 824 372V380C824 397.673 809.673 412 792 412H691C673.327 412 659 397.673 659 380V372Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 508C659 490.327 673.327 476 691 476H792C809.673 476 824 490.327 824 508V516C824 533.673 809.673 548 792 548H691C673.327 548 659 533.673 659 516V508Z",
      fill: "#5CBAEB"
    }
  )
] });
export {
  VisualisationRawOutputsIcon
};
